import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

interface SidebarToggleButtonProps {
  isOpen: boolean;
  onClick: () => void;
  controlsId: string;
}

const SidebarToggleButton = ({ isOpen, onClick: toggleSidebar, controlsId }: SidebarToggleButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={styles.menuButton}
      onClick={toggleSidebar}
      aria-label={t(isOpen ? 'navigation.closeMenu' : 'navigation.openMenu')}
      aria-expanded={isOpen}
      aria-controls={controlsId}
      tabIndex={0}
    >
      <i className={`totem-icon ${isOpen ? 'totem-icon-cross-big' : 'totem-icon-menu'}`} />
    </button>
  );
};

export default SidebarToggleButton;
